import React from 'react';

function SlideThumbnail(props) {
   
    return (
      <div
        className={
          props.active === true
            ? "img-thumb AW-animate-rise attiva"
            : "img-thumb AW-animate-rise"
        }
        idx={props.idx}
        onClick={(e) => props.clickHandler(e, props.idx)}
        >
        <img
          className="AW-previewImg"
          src={props.fileName}
          title={props.title}
          alt={props.alt}
        />
      </div>
    );
}

export default SlideThumbnail;